import { createMuiTheme as createTheme, ThemeOptions } from '@material-ui/core/styles';

import {
  customBackground,
  customBorders,
  customHeights,
  customShadows,
  customWidths,
  misc,
  navigation,
  overrides,
  palette,
  spacing,
  superAdmin,
  typography,
  zIndex,
} from './theme.options';
import { props } from './theme.props';

const themeDefaults = {
  customBackground,
  customBorders,
  customHeights,
  customShadows,
  customWidths,
  highlightBorderRadius: 3,
  misc,
  navigation,
  overrides,
  palette,
  props,
  spacing,
  superAdmin,
  typography,
  zIndex,
};

// Shallow merges given ThemeOptions with the Fountain UI defaults
export const createCustomTheme = (options: ThemeOptions) => createTheme({ ...themeDefaults, ...options });

// Refer to https://material-ui.com/customization/default-theme/
// for default theme. We are adding / overriding properties from default theme.
export const theme = createTheme(themeDefaults);
